import makeStyles from '@mui/styles/makeStyles'
import { OrderTable } from './OrderTable'

const useStyles = makeStyles(theme => ({
  orderTable: {
    height: '100%',
    overflow: 'auto',
    marginTop: theme.spacing(2.5),
  },
}))

interface OrderTableProps {
  setOrderCheck: (orderId: number, valueDiary: boolean) => any
}

export const OrderDisplay = ({
  setOrderCheck,
}: OrderTableProps) => {
  const classes = useStyles()

  return (
    <div className={classes.orderTable}>
      <OrderTable
        setOrderCheck={setOrderCheck}
      />
    </div>
  )
}
